import { Quill } from 'react-quill';

export const BASEURL = process.env.REACT_APP_SERVICE_URL;
export const IMAGEPATH = process.env.IMAGE_BASE_URL;

export const PAGE_SIZE = 10;
export const CURRENT_PAGE = 1;
export const DEFAULT_STALE_TIME = 1000 * 60 * 60;

export const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

export const RECEIVER_TYPE_ID = {
    PERSONALIZED: '4739c27e-f91a-4586-845a-2f25f29eac12',
    BATCH: '814dc7c6-9d43-44e8-a52b-abc99c76c650',
    GENERAL: '8d6fa44d-63f5-4649-8c85-0d62e0d98b78'
};

export const receiverTypes = [
    {
        name: 'Personalized',
        id: RECEIVER_TYPE_ID.PERSONALIZED
    },
    {
        name: 'Batch',
        id: RECEIVER_TYPE_ID.BATCH
    },
    {
        name: 'General',
        id: RECEIVER_TYPE_ID.GENERAL
    }
];

export const allRoles = [
    { name: 'Admin', id: '1ba91629-f1cf-4b50-82a6-f8427b5cb49c' },
    { name: 'Teacher', id: '0b38ed58-8873-4ff3-a369-f6c7486f4427' },
    { name: 'Admin Officer', id: 'bb960d5c-4e68-488b-8b44-682b8480431f' },
    { name: 'Student', id: '310bf6c9-4e91-4248-9935-02a1bf4032cf' },
    { name: 'Guardian', id: '3cd2c3d9-cbed-41a7-80fc-167fe823655c' }
];
export const allOrganizations = [
    {
        name: 'Octagon',
        id: '74444e28-89f5-45c5-9fcb-7496303809a1',
        address: 'House-14, Road-9, Sector-4, Uttara'
    }
];
export const ROLES = {
    ADMIN: '1ba91629-f1cf-4b50-82a6-f8427b5cb49c',
    TEACHER: '0b38ed58-8873-4ff3-a369-f6c7486f4427',
    ADMIN_OFFICER: 'bb960d5c-4e68-488b-8b44-682b8480431f',
    STUDENT: '310bf6c9-4e91-4248-9935-02a1bf4032cf',
    GUARDIAN: '3cd2c3d9-cbed-41a7-80fc-167fe823655c'
};

export const allRelationshipTypes = [
    { name: 'Father', id: '80b83ea4-469f-432c-9889-ba5cfa577986' },
    { name: 'Mother', id: 'b708c5fc-3328-4c8c-b5a8-7eb9cb003280' },
    { name: 'Other', id: 'd82de719-aa8e-4162-a391-50d6f2cdd704' }
];

export const RELATION_TYPE = {
    FATHER: '80b83ea4-469f-432c-9889-ba5cfa577986',
    MOTHER: 'b708c5fc-3328-4c8c-b5a8-7eb9cb003280',
    OTHER: 'd82de719-aa8e-4162-a391-50d6f2cdd704'
};

// Quill modules configuration
export const quillModules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link', 'image'],
        ['clean'],
        [{ color: [] }, { background: [] }]
    ],
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }
};

export const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color',
    'background'
];

export const diseaseAnimalRadioOptions: Record<string, string[]> = {
    cow: ['All Cows', 'Only Cow', 'Only Bull', 'Only Calves'],
    goat: ['goat', 'sheep', 'lambs']
};

export const getJoditConfig = (customHeight = '400') => {
    return {
        readonly: false,
        height: customHeight,
        toolbarAdaptive: false,
        // showXPathInStatusbar: false,  // Hides xpath in statusbar
        // showCharsCounter: false, // Hides chars counter
        // showWordsCounter: false, // Hides words counter
        creator: false, // Hides "powered by Jodit" text
        statusbar: true, // Hides the entire statusbar
        buttons: [
            'source',
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'ul',
            'ol',
            '|',
            'font',
            'fontsize',
            'brush',
            'paragraph',
            '|',
            'image',
            'table',
            'link',
            '|',
            'left',
            'center',
            'right',
            'justify',
            '|',
            'undo',
            'redo',
            '|',
            'hr',
            'eraser',
            'fullsize'
        ],
        uploader: {
            insertImageAsBase64URI: true
        },
        removeButtons: ['about']
    };
};
